import json from './sprite.js';

export default {
    handle: 'en_SPT16-Costume-Box',
    label: 'en_SPT16-Costume-Box',
    json,
};
